import { useApi } from "../../../swr/useApi";
import { productStorageService } from "../../api_client";
import type { ProductAttributeValueDto } from "../../../api";

export function useProductStorageValues() {
  return useApi<ProductAttributeValueDto[]>(
    "product-storage-values",
    async () => {
      return await productStorageService.getProductStorageValues();
    },
  );
}
